/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import firebase from 'firebase/compat/app';
import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { TicketIndexLogger } from './ticket-index-logger.service';
import { TicketIndexQuery } from './ticket-index-query';
import { SimpleIndexQuery } from './index-query/simple-index-query';
import { DateCentricIndexQuery, OrderByField } from './index-query/date-centric-index-query';

/**
 * Factory class for creating new objects of type
 * (and to get data provided by the Angular injector into non-Angular classes):
 *     - TicketIndexQuery
 *     - Index queries, which are subclasses of AbstractIndexQuery
 */
@Injectable({
	providedIn: 'root',
})
export class QueryFactory {
	constructor(private db: AngularFireDatabase, private logger: TicketIndexLogger) {}

	public newTicketIndexQuery() {
		return new TicketIndexQuery(this.db, this.logger);
	}

	public newSimpleIndexQuery(
		queryFunctionToApplyToRef: (ref: firebase.database.Reference) => firebase.database.Query
	): SimpleIndexQuery {
		return new SimpleIndexQuery(this.db, this.logger, queryFunctionToApplyToRef);
	}

	public newDateCentricIndexQuery(
		orderByField: OrderByField,
		date: string, // in the format YYYY-MM-DD
		numberBeforeDate: number, // an integer
		numberAfterDate: number // an integer
	): DateCentricIndexQuery {
		return new DateCentricIndexQuery(
			this.db,
			this.logger,
			orderByField,
			date,
			numberBeforeDate,
			numberAfterDate
		);
	}
}
